module.exports = __webpack_public_path__ + "static/media/cornerMatBlue10.8342f4c2.png";